
export default function MasterRowDataDef(masterName) {
    const columnMaps = new Map();
    const loremIpsumText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
    Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`;

    // Product rows
    const productRows = [
        { id: 1, productCode: 210493, productDescription: 'GII THREADERTAB EA', uom: '-', reportingUOM: 'EACH', conversionFactor: '-', franchise: 'Depuy-Joint & Mitek', subFranchise: 'MITEK', productCategory: 'MITEK', productBrand: 'GII', productGroup: 'MISC', productLine: 'NA', isActive: '-', dateOfDeactivation: '-' },
        { id: 2, productCode: 210708, productDescription: 'LUPINE LOOP PLUS ANCHOR W/ORTHOCORD', uom: '-', reportingUOM: 'EACH', conversionFactor: '-', franchise: 'Depuy-Joint & Mitek', subFranchise: 'MITEK', productCategory: 'MITEK', productBrand: 'BIOKNOTHLESS', productGroup: 'ANCH', productLine: 'NA', isActive: '-', dateOfDeactivation: '-' },
        { id: 3, productCode: 210709, productDescription: 'LUPINELOOPPLUS ANCHOR W/ORTHOCORD DS', uom: '-', reportingUOM: 'EACH', conversionFactor: '-', franchise: 'Depuy-Joint & Mitek', subFranchise: 'MITEK', productCategory: 'MITEK', productBrand: 'BIOKNOTHLESS', productGroup: 'MISC', productLine: 'NA', isActive: '-', dateOfDeactivation: '-' },
        { id: 4, productCode: 210711, productDescription: 'LUPINE BR W/ORTHCRD', uom: '-', reportingUOM: 'EACH', conversionFactor: '-', franchise: 'Depuy-Joint & Mitek', subFranchise: 'MITEK', productCategory: 'MITEK', productBrand: 'BIOKNOTHLESS', productGroup: 'MISC', productLine: 'NA', isActive: '-', dateOfDeactivation: '-' },
        { id: 5, productCode: 210800, productDescription: 'VERSALOK THREADER TAB EA', uom: '-', reportingUOM: 'EACH', conversionFactor: '-', franchise: 'Depuy-Joint & Mitek', subFranchise: 'MITEK', productCategory: 'MITEK', productBrand: 'VERSALOK', productGroup: 'MISC', productLine: 'NA', isActive: '-', dateOfDeactivation: '-' },
        { id: 6, productCode: 210811, productDescription: 'GRYPHON T BR W DS OC', uom: '-', reportingUOM: 'EACH', conversionFactor: '-', franchise: 'Depuy-Joint & Mitek', subFranchise: 'MITEK', productCategory: 'MITEK', productBrand: 'GRYPHON', productGroup: 'MISC', productLine: 'MB', isActive: '-', dateOfDeactivation: '-' },
    ];

    columnMaps.set('product', productRows);

    // Account rows
    const accountRows = [
        { id: 1, accountCode: 'D007', accountName: 'ADILABAD-DISTRICT HOSPITAL ADILIBAD ONGOLE & KING KOTI', city: 'ADILABAD', state: 'TELANGANA', region: 'SOUTH', accountType: 'HOSPITAL', accountClassification: 'GOVT' },
        { id: 2, accountCode: 'S2946', accountName: 'ADILABAD-SAI SAMRAKSHA ORTHOPAEDIC SUPER SPECIALITY HOSPITAL', city: 'ADILABAD', state: 'TELANGANA', region: 'SOUTH', accountType: 'HOSPITAL', accountClassification: 'PVT' },
        { id: 3, accountCode: 'S1719', accountName: 'ADILABAD-SRI SAI MATERNITY & GENERAL HOSPITAL', city: 'ADILABAD', state: 'TELANGANA', region: 'SOUTH', accountType: 'HOSPITAL', accountClassification: 'PVT' },
        { id: 4, accountCode: 'K343', accountName: 'ADONI-KRISHNA HOSPITALS', city: 'ADONI', state: 'ANDHRA PRADESH', region: 'SOUTH', accountType: 'HOSPITAL', accountClassification: 'PVT' },
        { id: 5, accountCode: 'H120', accountName: 'ADOOR-HOLY CROSS HOSPITAL', city: 'ADOOR', state: 'KERALA', region: 'SOUTH', accountType: 'HOSPITAL', accountClassification: 'PVT' },
    ];

    columnMaps.set('account', accountRows);

    // Surgeon rows
    const surgeonsRows = [
        { id: 1, surgeonCode: 'SSA0000001', city: 'TRIVANDRUM', state: 'KERALA', region: 'SOUTH', primaryContactNo: 9809134835, alternateContactNo: '-' },
        { id: 2, surgeonCode: 'SSA0000002', city: 'CHENNAI', state: 'TAMIL NADU', region: 'SOUTH', primaryContactNo: 9840081180, alternateContactNo: '-' },
        { id: 3, surgeonCode: 'SSA0000003', city: 'THANJAVUR', state: 'TAMIL NADU', region: 'SOUTH', primaryContactNo: 9843047078, alternateContactNo: '-' },
        { id: 4, surgeonCode: 'SSA0000005', city: 'UDUMALAIPETTAI', state: 'TAMIL NADU', region: 'SOUTH', primaryContactNo: 9842106540, alternateContactNo: '-' },
        { id: 5, surgeonCode: 'SSA0000007', city: 'BENGALURU', state: 'KARNATAKA', region: 'SOUTH', primaryContactNo: 9845019751, alternateContactNo: '-' },
    ];

    columnMaps.set('surgeons', surgeonsRows);

    const CategoryRows = [
        { id: 1, categoryName: 'JJ Core', description: loremIpsumText, seqNo: 1 },
        { id: 2, categoryName: 'JJ Connect', description: loremIpsumText, seqNo: 2 },

    ];

    columnMaps.set('helpcategory', CategoryRows);

    const MenuRows = [

        { id: 1, menuName: 'User Login', description: loremIpsumText, category: 'JJ Connect', seqNo: 1 },
        { id: 1, menuName: 'User Login', description: loremIpsumText, category: 'JJ Core', seqNo: 1 },
        { id: 2, menuName: 'Data Upload', description: loremIpsumText, category: 'JJ Core', seqNo: 2 },
        { id: 3, menuName: 'SNS Upload', description: loremIpsumText, category: 'JJ Core', seqNo: 3 },
        { id: 4, menuName: 'Month Closure', description: loremIpsumText, category: 'JJ Core', seqNo: 4 },
        { id: 5, menuName: 'Online entry', description: loremIpsumText, category: 'JJ Core', seqNo: 5 },

    ];

    columnMaps.set('helpmenus', MenuRows);

    const TransactionAllocationRows = [
        { id: 1, month: 'Feb-2023', split: '50%', franchise: 'ETHICON', download: 'file1.pdf', lastsplitdocno: 'DOC001', lastSplitDate: '16-Feb-2023' },
        { id: 2, month: 'Jan-2023', split: '30%', franchise: 'DEPUY-JOINTS', download: 'file2.doc', lastsplitdocno: 'DOC002', lastSplitDate: '15-Jan-2023' },
        //  { id: 3, month: 'Jan-2023', split: '20%', franchise: 'SYNTHES', download: 'file3.csv', lastsplitdocno: 'DOC003', lastSplitDate: '15-Jan-2023' },
        //  { id: 4, month: 'Jan-2023', split: '40%', franchise: 'ETHICON', download: 'file4.pdf', lastsplitdocno: 'DOC004', lastSplitDate: '15-Jan-2023' },
        //  { id: 5, month: 'Jan-2023', split: '60%', franchise: 'MITEK', download: 'file5.xlsx',     lastsplitdocno: 'DOC005', lastSplitDate: '15-Jan-2023' },
        //  { id: 6, month: 'Jun-2023', split: '25%', franchise: 'SYNTHES', download: 'file6.txt',     lastsplitdocno: 'DOC006', lastSplitDate: '15-Jan-2023' },
        //  { id: 7, month: 'Jul-2023', split: '35%', franchise: 'ETHICON', download: 'file7.doc',     lastsplitdocno: 'DOC007', lastSplitDate: '15-Jan-2023'},
        //  { id: 8, month: 'Aug-2023', split: '45%', franchise: 'DEPUY-JOINTS', download:    'file8.csv', lastsplitdocno: 'DOC008', lastSplitDate: '15-Jan-2023' },
        //  { id: 9, month: 'Sep-2023', split: '55%', franchise: 'MITEK', download: 'file9.pdf',  lastsplitdocno: 'DOC009', lastSplitDate: '15-Jan-2023' },
        //  { id: 10, month: 'Oct-2023', split: '70%', franchise: 'MITEK', download: 'file10.xlsx', lastsplitdocno: 'DOC010', lastSplitDate: '15-Jan-2023' }

    ];

    columnMaps.set('transactionallocation', TransactionAllocationRows);

    const AccountallocationRows = [
        {
            id: 1, month: 'Sep-2023', filename: 'RetailingInput1.xlsx', uploaddate: '01-Sep-2023', remark: 'approved by nikitam@sapl.net', summary: 'FileName :RetailingInput1.xlsx,Total Rows : 80,No Of Distributors : 30,No Of Accounts : 50', status: 'Pending'
        },
        { id: 2, month: 'Aug-2023', filename: 'RetailingInput2.xlsx', uploaddate: '01-Aug-2023', summary: 'FileName :RetailingInput2.xlsx,Total Rows : 80,No Of Distributors : 30,No Of Accounts : 50', status: 'Approved', remark: 'pending for verification' },
        { id: 3, month: 'Jul-2023', filename: 'RetailingInput3.xlsx', uploaddate: '15-Jul-2023', status: 'Approved', summary: 'FileName :RetailingInput3.xlsx,Total Rows : 80,No Of Distributors : 30,No Of Accounts : 50', remark: 'Rejected due to file data' },
        { id: 4, month: 'Jun-2023', filename: 'RetailingInput4.xlsx', uploaddate: '01-Jun-2023', status: 'Approved', summary: 'FileName :RetailingInput4.xlsx,Total Rows : 80,No Of Distributors : 30,No Of Accounts : 50', remark: 'approved by nikitam@sapl.net' },
        { id: 5, month: 'May-2023', filename: 'RetailingInput5.xlsx', uploaddate: '11-May-2023', status: 'Approved', summary: 'FileName :RetailingInput5.xlsx,Total Rows : 80,No Of Distributors : 30,No Of Accounts : 50', remark: '-' },

    ];

    columnMaps.set('accountverification', AccountallocationRows);

    const AccountallocationPreviewRows = [
        { rowNum: 1, recordType: '', errorMessage: '', month: 'Jan-2023', filename: 'example1.txt', uploaddate: '01-Jan-2023', status: 'Approved' },
        { rowNum: 2, recordType: '', errorMessage: '', month: 'Jan-2023', filename: 'example2.doc', uploaddate: '01-Jan-2023', status: 'Pending' },
        { rowNum: 3, recordType: '', errorMessage: '', month: 'Jan-2023', filename: 'example3.csv', uploaddate: '01-Jan-2023', status: 'Rejected' },
        { rowNum: 4, recordType: '', errorMessage: '', month: 'Jan-2023', filename: 'example4.pdf', uploaddate: '01-Jan-2023', status: 'Approved' },
        { rowNum: 5, recordType: '', errorMessage: '', month: 'Jan-2023', filename: 'example5.xlsx', uploaddate: '01-Jan-2023', status: 'Pending' },
    ];

    columnMaps.set('accountverificationimportpreview', AccountallocationPreviewRows);

    const topicrows = [
        { id: 1, categoryname: 'JJ Connect', description: loremIpsumText, publisheddate: `${new Date()}`, expirydate: `${new Date(new Date().getFullYear() + 2, new Date().getMonth(), new Date().getDate())}`, status: 'Active', topicname: 'Apply These 7 Secret Techniques To Improve Event', menuname: 'User Login', topictype: 'Article', ownerName: 'Nikita Mali', franchise: 'ETHICON', tags: ['ETHICON', 'MITEK', 'SPINE', 'ETHICON', 'MITEK', 'SPINE'], wwid: 1234, content:`<h1><strong>Heading H1</strong></h1><p><br></p><p><br></p><h2><strong>Heading H2</strong></h2><p><br></p><p><br></p><h3><strong>Heading H3</strong></h3><p><br></p><p><br></p><h4><strong>Heading H4</strong></h4><p><br></p><p><br></p><h5><strong>Heading H5</strong></h5><p><br></p><p><br></p><h6><strong>Heading H6</strong></h6><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><h3><strong>Paragraph</strong></h3><p><br></p><p>What is MTAweb Directory?</p><p><br></p><p>So you have heard about this site or you have been to it, but you cannot figure out what it is or what it can do. MTA web directory is the simplest way in which one can bid on a link, or a few links if they wish to do so. The link directory on MTA displays all of the links it currently has, and does so in alphabetical order, which makes it much easier for someone to find what they are looking for if it is something specific and they do not want to go through all the other sites and links as well. It allows you to start your bid at the bottom and slowly work your way to the top of the list.</p><p><br></p><p>With a very low costing starting bid of just $1, you are guaranteed to have a spot in MTA’s successful directory list. When you would like to increase your bid to one of the top positions, you have to know that this would be a wise decision to make as it will not only get your link to be at a higher point in the directory but it will also give you a chance to have your site advertised with the rest of the top ten on the home page of the website. This means that when visitors come to MTAweb.com, your site will be one of the first things they see. In other words, you stand a great chance at getting a comeback to your site sooner than you thought.</p><p><br></p><p><strong>This is strong text.</strong></p><p><br></p><p><em>This is italic text</em></p><p><br></p><p><u>This is underline text</u></p><p><br></p><p><br></p><p><br></p><p><br></p><h3><strong>Unordered list</strong></h3><p><br></p><ul><li>Implements <a href="https://docs-minimals.vercel.app/introduction" rel="noopener noreferrer" target="_blank" style="color: rgb(0, 102, 204);">This is an external link</a></li><li>Implements <a href="https://minimals.cc/dashboard/blog" rel="noopener noreferrer" target="_blank" style="color: rgb(0, 102, 204);">This is an inside link</a></li><li>Renders actual, "native" React DOM elements</li><li>Allows you to escape or skip HTML (try toggling the checkboxes above)</li><li>If you escape or skip the HTML, no dangerouslySetInnerHTML is used! Yay!</li></ul><p><br></p><p><br></p><p><br></p><p><br></p><h3><strong>Ordered list</strong></h3><p><br></p><ol><li>Analysis</li><li>Design</li><li>Implementation</li></ol><p><br></p><p><br></p><p><br></p><p><br></p><h3><strong>Blockquote</strong></h3><p><br></p><blockquote>Life is short, Smile while you still have teeth!&nbsp;</blockquote><p><br></p><p><br></p><p><br></p><p><br></p><h3><strong>Block Code</strong></h3><p><br></p><pre class="ql-syntax" spellcheck="false">import React from 'react';\nimport ReactDOM from 'react-dom';\nimport ReactMarkdown from 'react-markdown';\nimport rehypeHighlight from 'rehype-highlight';\n\nReactDOM.render(\n  &lt;ReactMarkdown rehypePlugins={[rehypeHighlight]}&gt;{'# Your markdown here'}&lt;/ReactMarkdown&gt;,\n  document.querySelector('#content')\n);\n</pre><p><br></p><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p><br></p><p><br></p><p>Why do we use it?</p><p><br></p><p><br></p><p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p><p><br></p><p><br></p><p><img src="https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_5.jpg"></p><p><br></p><p><br></p><p>It is important that you buy links because the links are what get you the results that you want. The popularity of the links that are listed in the MTA directory is in fact one of the most important factors in the performance of the search engine. Links are important and this is why you have to purchase a link in order to bid on something and the best part is that a link will only cost you $1, which is nothing compared to what you would pay if you decided to do it through any other company or website.</p><p><br></p><p><br></p><p><img src="https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_14.jpg"></p><p><br></p><p><br></p>` , cover : '/Images/image1.jpg'},

        {
            id: 2, categoryname: 'JJ Core', description: loremIpsumText, publisheddate: `${new Date()}`, expirydate: `${new Date(new Date().getFullYear() + 2, new Date().getMonth(), new Date().getDate())}`, status: 'Active', topicname: 'Believing These 7 Myths About Event Keeps You From Growing', menuname: 'SNS Upload', topictype: 'Video', ownerName: 'Nikita Mali', franchise: 'ETHICON', tags: ['MITEK', 'ETHICON', 'Meta'], wwid: 1234, cover: '/Images/image3.jpg', content:'/UploadFiles/uploadedvideos/Discussion on Monthly closure and G to N  process.-20231204_150404-Meeting Recording.mp4'
        },

        {
            id: 3, categoryname: 'JJ Core', description: loremIpsumText, publisheddate: `${new Date()}`, expirydate: `${new Date(new Date().getFullYear() + 2, new Date().getMonth(), new Date().getDate())}`, status: 'Active', topicname: 'Dont Waste Time! 7 Facts Until You Reach Your Event', menuname: 'Online Entry', topictype: 'Document', ownerName: 'Nikita Mali', franchise: 'MITEK', tags: ['The Kid', 'Toy Story', 'Meta'], wwid: 1234, cover: '/Images/image2.jpg', content:'/UploadFiles/documentsuploaded/483121836_9db5efefe22c454fad29f18c617254e5-150523-0445-762.pdf'
        },

        {
            id: 4, categoryname: 'JJ Core', description: loremIpsumText, publisheddate: `${new Date()}`, expirydate: `${new Date(new Date().getFullYear() + 2, new Date().getMonth(), new Date().getDate())}`, status: 'Active', topicname: 'Apply These 7 Secret Techniques To Improve Event', menuname: 'User Login', topictype: 'Video', ownerName: 'Nikita Mali', franchise: 'DEPUY JOINTS', tags: ['The Kid', 'Toy Story', 'Meta'], wwid: 1234, cover: '/Images/image3.jpg', content: '/UploadFiles/uploadedvideos/Discussion on Monthly closure and G to N  process.-20231204_150404-Meeting Recording.mp4'
        },

        {
            id: 5, categoryname: 'JJ Core', description: loremIpsumText, publisheddate: `${new Date()}`, expirydate: `${new Date(new Date().getFullYear() + 2, new Date().getMonth(), new Date().getDate())}`, status: 'In Active', topicname: 'Apply These 7 Secret Techniques To Improve Event', menuname: 'Month Closure', topictype: 'Video', ownerName: 'Nikita Mali', franchise: 'ETHICON', tags: ['The Kid', 'Toy Story', 'Meta'], wwid: 1234, cover: '/Images/image1.jpg', content: '/UploadFiles/uploadedvideos/Discussion on Monthly closure and G to N  process.-20231204_150404-Meeting Recording.mp4'
        },


    ];

    columnMaps.set('helptopics', topicrows);

    const newrequestcdatarows = [
        {
            "srno": 1,
            "requestStatus": "Drafts",
            "requestid": "REQ001",
            "requesttype": "Maintenance",
            "createdDate": "2023-12-01",
            "setName": "SetAlpha",
            "equipmentID": "E001",
            "equipmentAssignmentstatus":"Assigned",
            "approvalDate": "2023-12-02",
            "approvalstatus": "Approved",

            "customer": "CustomerX",
            "returnStatus": "Not Returned",
            "acknowledgementStatus": "Received"
        },
        {
            "srno": 2,
            "requestStatus": "Review",
            "requestid": "REQ002",
            "requesttype": "Installation",
            "createdDate": "2023-11-28",
            "setName": "SetBeta",
            "equipmentID": "E002",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-03",
            "approvalstatus": "Approved",

            "customer": "CustomerY",
            "returnStatus": "Returned",
            "acknowledgementStatus": "Not Received"
        },
        {
            "srno": 3,
            "requestStatus": "Dispatch",
            "requestid": "REQ003",
            "requesttype": "Repair",
            "createdDate": "2023-11-25",
            "setName": "SetGamma",
            "equipmentID": "E003",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-04",
            "approvalstatus": "Approved",

            "customer": "CustomerZ",
            "returnStatus": "Not Applicable",
            "acknowledgementStatus": "Received"
        },
        {
            "srno": 4,
            "requestStatus": "Reject",
            "requestid": "REQ004",
            "requesttype": "Upgrade",
            "createdDate": "2023-11-22",
            "setName": "SetDelta",
            "equipmentID": "E004",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-05",
            "approvalstatus":"Approved",
            "customer": "CustomerW",
            "returnStatus": "Not Returned",
            "acknowledgementStatus": "Not Received"
        },
        {
            "srno": 5,
            "requestStatus": "Drafts",
            "requestid": "REQ005",
            "requesttype": "Inspection",
            "createdDate": "2023-11-19",
            "setName": "SetEpsilon",
            "equipmentID": "E005",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-06",
            "approvalstatus": "Approved",

            "customer": "CustomerV",
            "returnStatus": "Returned",
            "acknowledgementStatus": "Received"
        },
          {
            "srno": 1,
            "requestStatus": "Drafts",
            "requestid": "REQ001",
            "requesttype": "Maintenance",
            "createdDate": "2023-12-01",
            "setName": "SetAlpha",
            "equipmentID": "E001",
            "equipmentAssignmentstatus": "Assigned",
            "approvalDate": "2023-12-02",
            "approvalstatus": "Approved",

            "customer": "CustomerX",
            "returnStatus": "Not Returned",
            "acknowledgementStatus": "Received"
        },
        {
            "srno": 2,
            "requestStatus": "Review",
            "requestid": "REQ002",
            "requesttype": "Installation",
            "createdDate": "2023-11-28",
            "setName": "SetBeta",
            "equipmentID": "E002",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-03",
            "approvalstatus": "Approved",

            "customer": "CustomerY",
            "returnStatus": "Returned",
            "acknowledgementStatus": "Not Received"
        },
        {
            "srno": 3,
            "requestStatus": "Dispatch",
            "requestid": "REQ003",
            "requesttype": "Repair",
            "createdDate": "2023-11-25",
            "setName": "SetGamma",
            "equipmentID": "E003",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-04",
            "approvalstatus": "Approved",

            "customer": "CustomerZ",
            "returnStatus": "Not Applicable",
            "acknowledgementStatus": "Received"
        },
        {
            "srno": 4,
            "requestStatus": "Reject",
            "requestid": "REQ004",
            "requesttype": "Upgrade",
            "createdDate": "2023-11-22",
            "setName": "SetDelta",
            "equipmentID": "E004",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-05",
            "approvalstatus": "Approved",
            "customer": "CustomerW",
            "returnStatus": "Not Returned",
            "acknowledgementStatus": "Not Received"
        },
        {
            "srno": 5,
            "requestStatus": "Drafts",
            "requestid": "REQ005",
            "requesttype": "Inspection",
            "createdDate": "2023-11-19",
            "setName": "SetEpsilon",
            "equipmentID": "E005",
            "equipmentAssignmentstatus": "Assigned",

            "approvalDate": "2023-12-06",
            "approvalstatus": "Approved",

            "customer": "CustomerV",
            "returnStatus": "Returned",
            "acknowledgementStatus": "Received"
        }
    ]

    const generatedRecords = [];
    const AlphaCode = 65; // ASCII code for 'A'

    for (let i = 1; i <= 200; i+=1) {
        generatedRecords.push({
            srno: i,
            requestStatus: i % 2 === 0 ? "Drafts" : "Review",
            requestid: `REQ${String(i).padStart(3, '0')}`,
            requesttype: i % 3 === 0 ? "Maintenance" : "Installation",
            createdDate: "2023-12-01",
            setName: `Set${String.fromCharCode(AlphaCode + i % 26)}`,
            equipmentID: `E${String(i).padStart(3, '0')}`,
            equipmentAssignmentstatus: "Assigned",
            approvalDate: "2023-12-02",
            approvalstatus: i % 5 === 0 ? "Approved" : "Pending",
            customer: `Customer${String.fromCharCode(65 + i % 26)}`,
            returnStatus: i % 4 === 0 ? "Returned" : "Not Returned",
            acknowledgementStatus: i % 6 === 0 ? "Received" : "Not Received",
        });
    }

   // console.log(generatedRecords);

    columnMaps.set('newrequest', generatedRecords);

    const emptyRows = [];

    columnMaps.set('distributor', emptyRows);
    columnMaps.set('areatree', emptyRows);
    columnMaps.set('saleshierarchy', emptyRows);
    columnMaps.set('netrealizationrate', emptyRows);
    columnMaps.set('fieldstaffallocation', emptyRows);
    columnMaps.set('user', emptyRows);
    columnMaps.set('customersalesteam', emptyRows);
    columnMaps.set('useraccessrights', emptyRows);

    // Allied master rows
    columnMaps.set('distributorgroup', emptyRows);
    columnMaps.set('uom', emptyRows);
    columnMaps.set('franchise', emptyRows);
    columnMaps.set('subfranchise', emptyRows);
    columnMaps.set('productgroup', emptyRows);
    columnMaps.set('productcategory', emptyRows);
    columnMaps.set('productbrand', emptyRows);
    columnMaps.set('productline', emptyRows);
    columnMaps.set('accountgroup', emptyRows);
    columnMaps.set('accounttype', emptyRows);
    columnMaps.set('accountclassification', emptyRows);
    columnMaps.set('accountsegmentation', emptyRows);
    columnMaps.set('surgeoncontacttype', emptyRows);
    columnMaps.set('surgeonsubcontacttype', emptyRows);
    columnMaps.set('citytier', emptyRows);


    return columnMaps.get(masterName);
}
